import {
  ABSplitEditor,
  AttributeSplitEditor,
  CallWebhookEditor,
  ChangeUserFieldEditor,
  ChannelOptEditorManager,
  DelayEditor,
  FacebookCustomAudienceEditor,
  FieldsMatchEditor,
  HoldEditor,
  HoldUntilReplyEditor,
  ModifyListMembershipEditor,
  ModifySubscriptionEditor,
  SendEmailEditor,
  SendInAppEditor,
  SendEmbeddedEditor,
  SendPushEditor,
  SendSMSEditor,
  SendWebPushEditor,
  SendWhatsAppEditor,
  StartNodeEditor,
  TriggerWorkflowEditor,
} from 'modules/workflowNodeEditors';
import { NODE_TYPES } from 'modules/workflows/constants';
import { DRAWER_SIZES } from 'ui/workflows/drawer/constants';

export const editorComponentByType = {
  [NODE_TYPES.AB_SPLIT]: ABSplitEditor,
  [NODE_TYPES.ADD_CONTACT]: ModifyListMembershipEditor,
  [NODE_TYPES.ADD_USER_TO_FB]: FacebookCustomAudienceEditor,
  [NODE_TYPES.ATTRIBUTE_SPLIT]: AttributeSplitEditor,
  [NODE_TYPES.CALL_WEBHOOK]: CallWebhookEditor,
  [NODE_TYPES.CHANGE_CONTACT_FIELD]: ChangeUserFieldEditor,
  [NODE_TYPES.CHANNEL_OPT]: ChannelOptEditorManager,
  [NODE_TYPES.DELAY]: DelayEditor,
  [NODE_TYPES.FIELDS_MATCH]: FieldsMatchEditor,
  [NODE_TYPES.HOLD]: HoldEditor,
  [NODE_TYPES.HOLD_UNTIL_REPLY]: HoldUntilReplyEditor,
  [NODE_TYPES.MODIFY_CHANNEL_SUBSCRIPTION]: ModifySubscriptionEditor,
  [NODE_TYPES.MODIFY_MESSAGE_TYPE]: ModifySubscriptionEditor,
  [NODE_TYPES.REMOVE_CONTACT]: ModifyListMembershipEditor,
  [NODE_TYPES.REMOVE_USER_FROM_FB]: FacebookCustomAudienceEditor,
  [NODE_TYPES.SEND_EMAIL]: SendEmailEditor,
  [NODE_TYPES.SEND_IN_APP]: SendInAppEditor,
  [NODE_TYPES.SEND_EMBEDDED]: SendEmbeddedEditor,
  [NODE_TYPES.SEND_PUSH]: SendPushEditor,
  [NODE_TYPES.SEND_SMS]: SendSMSEditor,
  [NODE_TYPES.SEND_WEB_PUSH]: SendWebPushEditor,
  [NODE_TYPES.SEND_WHATSAPP]: SendWhatsAppEditor,
  [NODE_TYPES.START]: StartNodeEditor,
  [NODE_TYPES.TRIGGER_WORKFLOW]: TriggerWorkflowEditor,
  [NODE_TYPES.UPDATE_CONTACT_WEBHOOK]: ChangeUserFieldEditor,
};

export const getEditorWidth = (nodeClass: string) => {
  switch (nodeClass) {
    case NODE_TYPES.FIELDS_MATCH:
      return DRAWER_SIZES.XLARGE;
    case NODE_TYPES.START:
      return DRAWER_SIZES.MEDIUM;
    case NODE_TYPES.HOLD:
      return DRAWER_SIZES.LARGE;
    default:
      return DRAWER_SIZES.SMALL;
  }
};
